export default __webpack_public_path__ + "static/media/calendar-check-mark.3157ea48.svg";